<div>
  <div class="tenant-case-domains-card rounded-3 bg-white border shadow-sm">
    <div class="d-flex align-items-center justify-content-between gap-2 mb-3">
      <div class="text-uppercase tenant-case-domains-heading">Active case domains</div>
      <button type="button" class="btn btn-light btn-sm rounded-small border px-3" @click="go_to_add_domain">
        + Add domain
      </button>
    </div>

    <div v-if="loading_domains" class="tenant-case-domains-empty text-center text-secondary small">
      Loading case domains...
    </div>

    <div v-else-if="domains_error" class="tenant-case-domains-empty text-center text-secondary small">
      {{ domains_error }}
    </div>

    <div v-else-if="!domains.length" class="tenant-case-domains-empty text-center text-secondary small">
      No case domains configured yet.
    </div>

    <div v-else class="tenant-case-domains-grid">
      <article v-for="domain in domains" :key="domain.id" class="tenant-case-domain-item">
        <span class="tenant-case-domain-badge" :class="domain.badge_class">
          {{ domain.name }}
        </span>

        <div class="tenant-case-domain-stats">
          <span class="tenant-case-domain-count">{{ domain.open_count }}</span>
          <span> open &middot; {{ domain.fields_count }} fields &middot; {{ domain.rules_count }} rules</span>
        </div>

        <div class="tenant-case-domain-meta text-uppercase">
          Schema &middot; {{ domain.version }} &middot; Last edit {{ domain.last_edit }} by {{ domain.updated_by }}
        </div>

        <div class="d-flex flex-wrap gap-2 mt-3">
          <button type="button" class="btn btn-light btn-sm rounded-small border px-3">
            Edit schema
          </button>
          <button type="button" class="btn btn-light btn-sm rounded-small border px-3">
            Form builder
          </button>
        </div>
      </article>
    </div>
  </div>

  <div
    v-if="show_add_domain_modal"
    class="company-case-modal-backdrop d-flex align-items-center justify-content-center"
    @click.self="close_add_domain_modal"
  >
    <section class="company-case-modal bg-white">
      <header class="company-case-modal-header d-flex align-items-start justify-content-between gap-3">
        <div>
          <h2 class="company-case-modal-title mb-2">Add domain</h2>
          <div class="company-case-modal-copy">Create a new case domain by adding an entity type.</div>
        </div>
        <button type="button" class="company-case-modal-close btn border-0 p-0" aria-label="Close modal" @click="close_add_domain_modal">
          <i class="bi bi-x-lg"></i>
        </button>
      </header>

      <div class="company-case-modal-body">
        <div v-if="add_domain_error" class="alert alert-danger small py-2 mb-3">
          {{ add_domain_error }}
        </div>

        <div class="mb-3">
          <label class="company-case-modal-label text-uppercase mb-2" for="tenant_domain_name">Domain name</label>
          <input
            id="tenant_domain_name"
            v-model.trim="add_domain_form.entity_type_name"
            type="text"
            class="form-control company-case-modal-control"
            placeholder="Enter domain name"
            :disabled="creating_domain"
          >
        </div>

        <div class="mb-0">
          <label class="company-case-modal-label text-uppercase mb-2" for="tenant_domain_description">Description</label>
          <textarea
            id="tenant_domain_description"
            v-model.trim="add_domain_form.entity_type_description"
            class="form-control company-case-modal-control company-case-modal-textarea"
            rows="4"
            placeholder="Enter description"
            :disabled="creating_domain"
          ></textarea>
        </div>
      </div>

      <footer class="company-case-modal-footer d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-light border px-4" :disabled="creating_domain" @click="close_add_domain_modal">Cancel</button>
        <button type="button" class="btn btn-primary-dark px-4 d-inline-flex align-items-center gap-2" :disabled="creating_domain" @click="create_domain">
          <span v-if="creating_domain" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{ creating_domain ? 'Saving...' : 'Save' }}
        </button>
      </footer>
    </section>
  </div>
</div>
